
import Vue from 'vue'
import { fetchChangelogEntries, formatChangelogDateLong } from '@/utils/changelog'

interface ChangelogItem {
  id: number
  date: string
  title: string
  description: string
}

export default Vue.extend({
  name: 'Changelog',
  data() {
    return {
      loading: false,
      error: null as string | null,
      items: [] as ChangelogItem[],
    }
  },
  created() {
    document.title = String(this.$vuetify.lang.t('$vuetify.tab_titles.changelog'))
    this.fetch()
  },
  methods: {
    async fetch() {
      this.loading = true
      this.error = null
      const { items, error } = await fetchChangelogEntries<ChangelogItem>('/v1/changelog', { limit: 50 })
      this.items = items
      this.error = error
      this.loading = false
    },
    formatDate(value: string): string {
      return formatChangelogDateLong(value, String(this.$vuetify.lang.current))
    },
  },
})
